var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    fill: "#22E06C",
    viewBox: "4 4.5 24 24",
    enableBackground: "new 4 4.5 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico__x2F__feed"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.222,26.5c-0.611,0-1.134-0.217-1.569-0.652C6.219,25.413,6.001,24.89,6,24.278V8.722 c0-0.611,0.218-1.134,0.653-1.569S7.612,6.501,8.222,6.5h12.223L26,12.056v12.223c0,0.61-0.217,1.135-0.652,1.569 c-0.435,0.436-0.958,0.653-1.569,0.652H8.222z M10.444,22.055h11.11v-2.222h-11.11V22.055z M10.444,17.611h11.11v-2.223h-11.11 V17.611z M19.333,13.167h4.445l-4.445-4.444V13.167z M10.444,13.167H16v-2.222h-5.556V13.167z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeed);
export default __webpack_public_path__ + "static/media/feed.c28f14fea2346b1b75f1083ab78ba00f.svg";
export { ForwardRef as ReactComponent };